<template>
  <div>
    <v-btn v-if="editable" class="btn-add-category" :aria-label="$t('Добавить файл')" @click.native.stop="resetFile( true)">
      <span class="pro-icon-add" aria-hidden="true"></span>
    </v-btn>
    <v-dialog v-model="fileDialog" max-width="600">
      <v-card class="modal">
        <div class="modal-head">
          {{ $t("Файлы ответа") }}
          <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="resetFile(false)">
            <span class="pro-icon-close1" aria-hidden="true"></span>
          </v-btn>
        </div>
        <div class="modal-body">
          <div class="files">
            <div class="file-item">
              <v-row>
                <v-col cols="12" sm="12" class="col-file-input">
                  <div class="file-item">
                    <i
                      role="button"
                      tabindex="0"
                      :aria-label="$t('Выберите файлы')"
                      class="v-icon notranslate v-icon--link mdi mdi-paperclip theme--light"
                    ></i>
                    <v-file-input
                      :label="$t('Выберите файлы')"
                      v-model="uploadedFiles"
                      class="v-input__control"
                      multiple
                    >
                    </v-file-input>
                  </div>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-btn color="primary" dark @click="addFile">
                    Добавить
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <ul class="files-l" v-for="file in files" :key="file.name">
      <li>
        <a :href="baseUrl + file.link" target="_blank">{{ file.name }}</a>
        <span
          v-if="editable"
          class="pro-icon-close"
          role="button"
          tabindex="0"
          :aria-label="$t('Удалить файл') + ': ' + file.name"
          @click="deleteFile(file.name)"
          @keydown.enter.prevent="deleteFile(file.name)"
          @keydown.space.prevent="deleteFile(file.name)"
        ></span>
      </li>
    </ul>
  </div>
</template>

<script>
  import Appeal from '@/model/appeal'

  export default {
    props: {
      files: Array,
      editable: Boolean
    },
    computed: {
      listLocal: {
        get() {
          return this.files
        },
        set(newList) {
          this.$emit('update:files', newList)
        }
      }
    },
    data: () => ({
      fileDialog: false,
      uploadedFiles: [],
      baseUrl: process.env.VUE_APP_BACK_URL
    }),
    methods: {
      // Обновление формы для добавления
      resetFile(flag) {
        this.fileDialog = flag
        this.uploadedFiles = []
      },
      // Добавление файлов
      addFile() {
        const fd = new FormData()

        this.uploadedFiles.forEach(function (element, index) {
          fd.append(`appeal[uploadedFiles][${index}][uploadedFile]`, element)
        })

        Appeal.updateReplyFiles(fd, this.$route.params.id)
          .then((res) => {
            if (res.status === 200) this.$parent.fetchData()
          })
          .catch((err) => console.log(err))
        this.resetFile(false)
      },
      // Удаление файла
      deleteFile(fileName) {
        if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
          Appeal.deleteFile(this.$route.params.id, fileName)
            .then((res) => {
              if (res.status === 200) this.$parent.fetchData()
            })
            .catch((err) => console.log(err))
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .col-sm-2,
  .col-sm-3,
  .col-sm-9,
  .col-sm-10 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .form-files {
    label {
      min-width: auto;
    }
  }

  .files {
    .file-item {
      display: flex;

      i {
        position: relative;
        top: -4px;
      }

      .v-input {
        max-width: 240px;
        margin: 0;
        padding: 0;
        white-space: nowrap;
      }
    }
  }
</style>
